import { gql } from '@apollo/client';

export default gql`
  query getTicketDetails($ticketNumbers: [String]!) {
    getTicketDetails(ticketNumbers: $ticketNumbers) {
      ticketNumber
      bookingNumber
      materialConflict
      conflicts
    }
  }
`;
